import { CfCoreGalleryAnimation } from './cf-core-gallery-animation.model';
import { CfCoreGalleryImageSize } from './cf-core-gallery-image-size.model';

export interface ICfCoreGalleryOptions {
    width?: string;
    height?: string;
    breakpoint?: number;
    fullWidth?: boolean;
    image?: boolean;
    imagePercent?: number;
    imageArrows?: boolean;
    imageArrowsAutoHide?: boolean;
    imageSwipe?: boolean;
    imageAnimation?: string;
    imageSize?: string;
    thumbnails?: boolean;
    thumbnailsColumns?: number;
    thumbnailsRows?: number;
    thumbnailsPercent?: number;
    thumbnailsMargin?: number;
    thumbnailsArrows?: boolean;
    thumbnailsArrowsAutoHide?: boolean;
    thumbnailsSwipe?: boolean;
    thumbnailMargin?: number;
    preview?: boolean;
    previewDescription?: boolean;
    previewSwipe?: boolean;
    previewFullscreen?: boolean;
    previewCloseOnClick?: boolean;
    previewKeyboardNavigation?: boolean;
}
export class CfCoreGalleryOptions implements ICfCoreGalleryOptions {
    width?: string;
    height?: string;
    breakpoint?: number;
    fullWidth?: boolean;
    image?: boolean;
    imagePercent?: number;
    imageArrows?: boolean;
    imageArrowsAutoHide?: boolean;
    imageSwipe?: boolean;
    imageAnimation?: string;
    imageSize?: string;
    thumbnails?: boolean;
    thumbnailsColumns?: number;
    thumbnailsRows?: number;
    thumbnailsPercent?: number;
    thumbnailsMargin?: number;
    thumbnailsArrows?: boolean;
    thumbnailsArrowsAutoHide?: boolean;
    thumbnailsSwipe?: boolean;
    thumbnailMargin?: number;
    preview?: boolean;
    previewDescription?: boolean;
    previewSwipe?: boolean;
    previewFullscreen?: boolean;
    previewCloseOnClick?: boolean;
    previewKeyboardNavigation?: boolean;
/**
 * @param {?} obj
 */
constructor(obj: ICfCoreGalleryOptions) {

        const preventDefaults = obj.breakpoint === undefined ? false : true;

        function use<T>(source: T, defaultValue: T): T {
            return obj && (source !== undefined || preventDefaults) ? source : defaultValue;
        }

        this.breakpoint = use(obj.breakpoint, undefined);
        this.width = use(obj.width, '500px');
        this.height = use(obj.height, '400px');
        this.fullWidth = use(obj.fullWidth, false);

        this.image = use(obj.image, true);
        this.imagePercent = use(obj.imagePercent, 75);
        this.imageArrows = use(obj.imageArrows, true);
        this.imageArrowsAutoHide = use(obj.imageArrowsAutoHide, false);
        this.imageSwipe = use(obj.imageSwipe, false);
        this.imageAnimation = use(obj.imageAnimation, CfCoreGalleryAnimation.Fade);
        this.imageSize = use(obj.imageSize, CfCoreGalleryImageSize.Cover);

        this.thumbnails = use(obj.thumbnails, true);
        this.thumbnailsColumns = use(obj.thumbnailsColumns, 4);
        this.thumbnailsRows = use(obj.thumbnailsRows, 1);
        this.thumbnailsPercent = use(obj.thumbnailsPercent, 25);
        this.thumbnailsMargin = use(obj.thumbnailsMargin, 10);
        this.thumbnailsArrows = use(obj.thumbnailsArrows, true);
        this.thumbnailsArrowsAutoHide = use(obj.thumbnailsArrowsAutoHide, false);
        this.thumbnailsSwipe = use(obj.thumbnailsSwipe, false);
        this.thumbnailMargin = use(obj.thumbnailMargin, 10);

        this.preview = use(obj.preview, true);
        this.previewDescription = use(obj.previewDescription, true);
        this.previewSwipe = use(obj.previewSwipe, false);
        this.previewFullscreen = use(obj.previewFullscreen, false);
        this.previewCloseOnClick = use(obj.previewCloseOnClick, false);
        this.previewKeyboardNavigation = use(obj.previewKeyboardNavigation, false);
    }
}

function CfCoreGalleryOptions_tsickle_Closure_declarations() {
/** @type {?} */
CfCoreGalleryOptions.prototype.width;
/** @type {?} */
CfCoreGalleryOptions.prototype.height;
/** @type {?} */
CfCoreGalleryOptions.prototype.breakpoint;
/** @type {?} */
CfCoreGalleryOptions.prototype.fullWidth;
/** @type {?} */
CfCoreGalleryOptions.prototype.image;
/** @type {?} */
CfCoreGalleryOptions.prototype.imagePercent;
/** @type {?} */
CfCoreGalleryOptions.prototype.imageArrows;
/** @type {?} */
CfCoreGalleryOptions.prototype.imageArrowsAutoHide;
/** @type {?} */
CfCoreGalleryOptions.prototype.imageSwipe;
/** @type {?} */
CfCoreGalleryOptions.prototype.imageAnimation;
/** @type {?} */
CfCoreGalleryOptions.prototype.imageSize;
/** @type {?} */
CfCoreGalleryOptions.prototype.thumbnails;
/** @type {?} */
CfCoreGalleryOptions.prototype.thumbnailsColumns;
/** @type {?} */
CfCoreGalleryOptions.prototype.thumbnailsRows;
/** @type {?} */
CfCoreGalleryOptions.prototype.thumbnailsPercent;
/** @type {?} */
CfCoreGalleryOptions.prototype.thumbnailsMargin;
/** @type {?} */
CfCoreGalleryOptions.prototype.thumbnailsArrows;
/** @type {?} */
CfCoreGalleryOptions.prototype.thumbnailsArrowsAutoHide;
/** @type {?} */
CfCoreGalleryOptions.prototype.thumbnailsSwipe;
/** @type {?} */
CfCoreGalleryOptions.prototype.thumbnailMargin;
/** @type {?} */
CfCoreGalleryOptions.prototype.preview;
/** @type {?} */
CfCoreGalleryOptions.prototype.previewDescription;
/** @type {?} */
CfCoreGalleryOptions.prototype.previewSwipe;
/** @type {?} */
CfCoreGalleryOptions.prototype.previewFullscreen;
/** @type {?} */
CfCoreGalleryOptions.prototype.previewCloseOnClick;
/** @type {?} */
CfCoreGalleryOptions.prototype.previewKeyboardNavigation;
}

